import { c as _c } from "react/compiler-runtime";
import type { ElementType, PropsWithChildren } from 'react';
import { cx } from '../../cx';
import type { ButtonAsProps } from '../../polymorphic-props';
import { uiTestId } from '../../test-ids';
import type { LoadingButtonProps } from '../button/loading-button';
import { LoadingButton } from '../button/loading-button';
function Root(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex justify-between gap-4 p-6 sm:px-8 sm:pt-4 sm:pb-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function Button(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = uiTestId("Modal.Footer.Button");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <LoadingButton data-testid={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const InfoBox = t0 => {
  const $ = _c(6);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = uiTestId("Modal.Footer.InfoBox");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = cx("w-full", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div data-testid={t1} className={t2}>{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const Actions = t0 => {
  const $ = _c(6);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = uiTestId("Modal.Footer.Actions");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = cx("ml-auto flex flex-1 justify-end gap-4 *:only:w-full sm:flex-initial sm:*:flex-initial", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div data-testid={t1} className={t2}>{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const Footer = Object.assign(Root, {
  Button,
  InfoBox,
  Actions
});